import { observer } from 'mobx-react-lite'
import { Box, FullPageWrapper, SpinnerLoader } from 'shared/ui'
import { VoicemailDropEmpty } from 'pages/settings/pages/personal/pages/account/pages/voicemailDrop/ui/VoicemailDropEmpty/VoicemailDropEmpty'
import {
  useVoicemailDropContext,
  VoicemailDropProvider,
} from 'pages/settings/pages/personal/pages/account/pages/voicemailDrop/context/voicemailDropContext'
import { AddVoicemailAudioButton } from 'pages/settings/pages/personal/pages/account/pages/voicemailDrop/ui/AddVoicemailAudioButton/AddVoicemailAudioButton'
import { VoicemailDropToggle } from 'pages/settings/pages/personal/pages/account/pages/voicemailDrop/ui/VoicemailDropToggle/VoicemailDropToggle'
import { VoicemailDropTable } from 'pages/settings/pages/personal/pages/account/pages/voicemailDrop/ui/VoicemailDropListTable/VoicemailDropTable'

const VoicemailDrop = observer(() => {
  const store = useVoicemailDropContext()
  const { isEmpty, initialLoading, voicemailDropActive } = store

  if (initialLoading) return <SpinnerLoader ariaLabel={'VoicemailDropPage'} />
  if (isEmpty) return <VoicemailDropEmpty />

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      width={'100%'}
      paddingTop={'23px'}
      flexGrow={'1'}
    >
      <Box paddingLeft={'4px'} paddingRight={'4px'}>
        <VoicemailDropToggle />
      </Box>
      {voicemailDropActive && (
        <>
          <Box padding={'8px 4px 24px'}>
            <AddVoicemailAudioButton store={store} />
          </Box>
          <VoicemailDropTable />
        </>
      )}
    </Box>
  )
})

export const VoicemailDropPage = observer(() => {
  return (
    <FullPageWrapper>
      <VoicemailDropProvider>
        <VoicemailDrop />
      </VoicemailDropProvider>
    </FullPageWrapper>
  )
})
